import type { ResearchFocusArea, ResearchRun } from '@/types';

const FOCUS_TAG_MAP: Record<string, ResearchFocusArea> = {
  MARKET: 'market',
  MARKT: 'market',
  COMPETITORS: 'competitors',
  AUDIENCE: 'audience',
  CHANNELS: 'channels',
  TRENDS: 'trends',
};

/** Parses `[MARKET – Jahr 2026]` prefix from strategy research queries. */
export function inferFocusFromQuery(query: string): ResearchFocusArea | null {
  const m = query.trim().match(/^\[([A-ZÄÖÜ_]+)\s*[–-]/i);
  const raw = m?.[1];
  if (!raw) return null;
  const tag = raw.toUpperCase();
  return FOCUS_TAG_MAP[tag] ?? null;
}

export interface ResearchRunFilterState {
  search: string;
  provider: string;
  status: string;
  focus: string;
  /** `all` oder `starred` — nur markierte Research-Runs */
  star: string;
}

const ALL = 'all';

/** Nur Einträge mit `is_starred` (Filter-Dropdown). */
export const FILTER_STARRED = 'starred';

export function filterResearchRuns(runs: ResearchRun[], f: ResearchRunFilterState): ResearchRun[] {
  const q = f.search.trim().toLowerCase();
  return runs.filter((run) => {
    if (f.star === 'starred' && !run.is_starred) return false;
    if (f.provider !== ALL && run.provider !== f.provider) return false;
    if (f.status !== ALL && run.status !== f.status) return false;
    if (f.focus !== ALL) {
      const inferred = inferFocusFromQuery(run.query);
      if (inferred !== f.focus) return false;
    }
    if (!q) return true;
    const inQuery = run.query.toLowerCase().includes(q);
    const inSummary = (run.summary ?? '').toLowerCase().includes(q);
    return inQuery || inSummary;
  });
}

export const FILTER_ALL = ALL;
